import { fetchAuthSession } from "aws-amplify/auth";
import instance from "../apis/user";
import axios from "axios";
import { errorDeApi } from "./client";

const checkUserStatus = async (email) => {
    try {
        const response = await instance.post("/api/auth/check-user-status", { email });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const getAccessToken = async () => {
    try {
        // Sin forceRefresh: ver el comentario en libs/axios.js.
        const { tokens } = await fetchAuthSession();
        return tokens?.accessToken?.toString();
    } catch (error) {
        return null;
    }
};

// Sin token no mandamos el header: antes salía `Bearer null` y el backend lo
// contaba como token presente pero ilegible → 401 confuso. Ver Usuarios.js.
const authHeaders = accessToken =>
    accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

const login = async (email, password) => {
    try {
        const response = await instance.post("/api/auth/login", { email, password });
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const Me = async () => {
    // 🧪 SOLO LOCAL — perfil ficticio sin backend de auth (gated por REACT_APP_LOCAL_AUTH).
    if (process.env.REACT_APP_LOCAL_AUTH === 'true') {
        return { sub: 'local-admin', name: 'Admin Local', email: 'local@test.cl', rut: '11111111-1', role: 'admin', 'custom:role': 'admin', birthdate: '1990-01-01' };
    }
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(`${process.env.REACT_APP_API_USERS}/api/auth/me`, {
            headers: authHeaders(accessToken)
        });
        return response.data.user;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const register = async (email, password, name, phone_number, birthdate, address, rut, gender, commune, enfermedadesBases) => {
    try {
        const response = await instance.post("/api/auth/register", {
            email, password, name, phone_number, birthdate, address, rut, gender, commune, enfermedadesBases
        });
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const confirmAccount = async (email, confirmationCode, password) => {
    try {
        const response = await instance.post("/api/auth/confirm-account", {
            email,
            code: confirmationCode,
            password
        });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const resendConfirmationCode = async (email, type) => {
    try {
        const response = await instance.post("/api/auth/resend-verification-code", { email, type });
        return response.data;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const forgotPassword = async (email) => {
    try {
        const response = await instance.post("/api/auth/forgot-password", { email });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const confirmForgotPassword = async (email, code, newPassword) => {
    try {
        const response = await instance.post("/api/auth/confirm-forgot-password", {
            email, code, newPassword
        });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const ChangePassword = async (oldPassword, newPassword) => {
    try {
        const accessToken = await getAccessToken();
        const response = await axios.post(`${process.env.REACT_APP_API_USERS}/api/auth/change-password`, {
            currentPassword: oldPassword,
            newPassword
        }, {
            headers: authHeaders(accessToken)
        });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

const UpdateProfile = async (profileData) => {
    try {
        const accessToken = await getAccessToken();
        const response = await axios.put(`${process.env.REACT_APP_API_USERS}/api/auth/profile`, profileData, {
            headers: authHeaders(accessToken)
        });
        return response;
    } catch (error) {
        throw errorDeApi(error);
    }
};

// Obtiene la hora actual del servidor para evitar manipulación del reloj del cliente
const getServerTime = async () => {
    try {
        const response = await instance.get("/api/auth/server-time");
        console.log('⏰ Hora del servidor recibida del backend:', response.now);
        return new Date(response.now);
    } catch (error) {
        // 🧪 SOLO LOCAL — no bloquear por la hora del servidor (endpoint de auth no
        // disponible/401 en local): usar la hora del cliente. Gated por REACT_APP_ENV.
        if (process.env.REACT_APP_ENV === 'local') return new Date();
        // ✅ Lanzar el error para que el caller decida qué hacer
        console.error("❌ Error obteniendo hora del servidor:", error.message);
        throw error;
    }
};

export default {
    login,
    Me,
    register,
    confirmAccount,
    resendConfirmationCode,
    forgotPassword,
    confirmForgotPassword,
    ChangePassword,
    UpdateProfile,
    checkUserStatus,
    getServerTime
};
